import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import getAssignedTasks from "../../controllers/Tasks/getTasks";
import { CircularProgress } from "@mui/material";
import Icon from "../HOC/Icon";
import moment from "moment";
import Button1 from "../form/Button1";
import { Link } from "react-router-dom";

export default function PendingTeamTasks() {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const [loadings, setLoadings] = useState({ load: false });
  const [data, setData] = useState([]);

  useEffect(() => {
    load();
    //eslint-disable-next-line
  }, []);
  async function load() {
    setLoadings({ ...loadings, load: true });
    let res = await getAssignedTasks({ offset: 0, limit: 10 });
    setLoadings({ ...loadings, load: false });
    if (res.return) {
      setData(res?.data?.data);
    }
  }

  // async function load() {
  //   setLoadings({ ...loadings, load: true });
  //   let res = await getAssignedTasks();
  //   setLoadings({ ...loadings, load: false });
  //   if (res.return) {
  //     setData(res?.data?.data);
  //   }
  // }

  function getTaskType(taskType) {
    if (taskType === "Ticketing") return "Ticket";
    if (taskType === "ChangeOrder") return "Ticket Re-issue";
    else if (taskType === "Refund") return "Ticket Refund";
    else if (taskType === "Void") return "Ticket Void";
    else if (taskType === "Support") return "Support";

    return "Custom Task";
  }
  function getTaskLink(obj) {
    if (obj?.taskType === "Ticketing")
      return (
        "/order/flight/ticket/detail/" +
        obj?.ticketManagement +
        "?page=Tickets&task=" +
        obj?._id
      );
    if (obj?.taskType === "ChangeOrder")
      return (
        "/order/flight/ticket/detail/" +
        obj?.changeOrderManagement +
        "?page=Date Change&task=" +
        obj?._id
      );
    else if (obj?.taskType === "Refund")
      return (
        "/order/flight/ticket/detail/" +
        obj?.refundTicketManagement +
        "?page=Refund Orders&task=" +
        obj?._id
      );
    else if (obj?.taskType === "Void")
      return (
        "/order/flight/ticket/detail/" +
        obj?.voidTicketManagement +
        "?page=Void Orders&task=" +
        obj?._id
      );
    else if (obj?.taskType === "Support") return "Support";

    return "/order";
  }

  const TaskCard = ({ task }) => (
    <div className="flex gap-4 min-h-[70px] py-2 pb-4">
      <Icon icon="iconamoon:ticket" className="!w-8 !h-8 !text-primary/50" />
      <div className="flex-1">
        <div>{getTaskType(task?.taskType)}</div>
        <p>{task?.note}</p>
      </div>
      <div className="flex flex-col gap-3 items-end">
        <p className="text-sm">{moment(task?.createdAt)?.fromNow()}</p>
        <Link
          to={getTaskLink(task)}
          className="text-theme1 flex gap-2 text-lg items-center"
        >
          View
          <Icon icon="weui:arrow-filled" />
        </Link>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      <h5 className="mx-6">Pending tasks</h5>
      <div className="card !p-10 flex flex-col gap-4">
        {loadings?.load ? (
          <div className="flex justify-center items-center p-4">
            <CircularProgress className="" />
          </div>
        ) : (
          data?.map((task, i) => (
            <div className="">
              <TaskCard key={i} {...{ task }} />
              <hr />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
